import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useIndividualsServiceGetV1IndividualsByIndividualId } from '../client/queries'
import { individual } from '../client/requests'

export type IndividualType = individual

export const useIndividual = (id?: string) => {
  const token = useFirebaseToken()

  return useIndividualsServiceGetV1IndividualsByIndividualId(
    { individualId: id! },
    undefined,
    {
      enabled: !!id && !!token,
    },
  )
}
